import { parseMarkdown, type Inline } from "@instead/shared";

/** Renders the D-22 subset as real React elements — no HTML string path. */
function Inlines({ inlines }: { inlines: Inline[] }) {
  return (
    <>
      {inlines.map((inl, i) => {
        switch (inl.kind) {
          case "bold":
            return <strong key={i}>{inl.text}</strong>;
          case "italic":
            return <em key={i}>{inl.text}</em>;
          case "link":
            return (
              <a key={i} href={inl.href} target="_blank" rel="noopener noreferrer">
                {inl.text}
              </a>
            );
          default:
            return <span key={i}>{inl.text}</span>;
        }
      })}
    </>
  );
}

const HEADING_CLASS = { 1: "title", 2: "micro", 3: "micro" } as const;

export function Markdown({ text }: { text: string }) {
  const blocks = parseMarkdown(text);
  return (
    <div style={{ display: "flex", flexDirection: "column", gap: "var(--sp-2)" }}>
      {blocks.map((b, i) => {
        if (b.kind === "heading") {
          const H = (["h3", "h4", "h5"] as const)[b.level - 1] ?? "h5";
          return (
            <H key={i} className={HEADING_CLASS[b.level]} style={b.level > 1 ? { textTransform: "uppercase" } : {}}>
              <Inlines inlines={b.inlines} />
            </H>
          );
        }
        if (b.kind === "list") {
          return (
            <ul key={i} style={{ paddingLeft: "1.2em", margin: 0 }}>
              {b.items.map((item, j) => (
                <li key={j}>
                  <Inlines inlines={item} />
                </li>
              ))}
            </ul>
          );
        }
        return (
          <p key={i} style={{ margin: 0 }}>
            <Inlines inlines={b.inlines} />
          </p>
        );
      })}
    </div>
  );
}
